[
  {
    "id": "MET-LEN-L2-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Djayden fietst naar school. De afstand is 1,5 kilometer. Hoeveel meter is dat?",
    "options": [
      "150 meter",
      "1500 meter",
      "15 meter",
      "15.000 meter"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-SCHOOL",
    "explanation": "Van km naar m zijn het 3 trapjes omlaag. Elke trap is ×10. Dus: 1,5 × 1000 = 1500 meter.",
    "distractorExplanations": {
      "0": "Je stopte bij hectometer. Nog één stapje verder naar meter!",
      "2": "Je deelde in plaats van keer gedaan. Een kilometer is juist veel groter dan een meter!",
      "3": "Te veel nullen! Check: 1,5 × 1000 = 1500."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 1.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L1-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een lint is 250 centimeter lang. Hoeveel meter is dat?",
    "options": [
      "0,25 m",
      "2,5 m",
      "25 m",
      "250 m"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-LINT",
    "explanation": "Van cm naar m zijn het 2 stappen omhoog op de trap. Dus delen door 100: 250 : 100 = 2,5 meter.",
    "distractorExplanations": {
      "0": "Je deelde door 1000. Dat is van mm naar m!",
      "2": "Je deelde door 10. Dat is van cm naar dm!",
      "3": "Dit is hetzelfde getal. Je moet het omrekenen naar meters."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "cm",
        "to": "m",
        "value": 250,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L1-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een klaslokaal is 6 meter lang. Hoeveel centimeter is dat?",
    "options": [
      "600 cm",
      "60 cm",
      "6.000 cm",
      "6 cm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-KLAS",
    "explanation": "Van meter naar centimeter zijn het 2 trapjes omlaag. Dus: 6 × 100 = 600 cm.",
    "distractorExplanations": {
      "1": "Je deed maar één stapje (m naar dm). Nog één stapje verder!",
      "2": "Je zette er een nul te veel bij. Het is ×100, niet ×1000.",
      "3": "Je zette niets om. 6 meter is veel meer dan 6 cm!"
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 6,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L1-004",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een touw is 45 decimeter lang. Hoeveel meter is dat?",
    "options": [
      "0,45 m",
      "4,5 m",
      "45 m",
      "450 m"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-TOUW",
    "explanation": "Van dm naar m is één stap omhoog. Dus delen door 10: 45 : 10 = 4,5 m.",
    "distractorExplanations": {
      "0": "Je deelde door 100. Dat is van cm naar m!",
      "2": "Je zette niets om. 45 dm is minder dan 45 m.",
      "3": "Je deed ×10 in plaats van ÷10."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "dm",
        "to": "m",
        "value": 45,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LEN-L1-005",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een potlood is 12 centimeter lang. Hoeveel millimeter is dat?",
    "options": [
      "120 mm",
      "12 mm",
      "1,2 mm",
      "1.200 mm"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-LEN-POTLOOD",
    "explanation": "Van cm naar mm is één trapje omlaag. Dus: 12 × 10 = 120 mm.",
    "distractorExplanations": {
      "1": "Je zette niets om. 12 cm is meer dan 12 mm.",
      "2": "Je deelde in plaats van keer. Naar mm ga je juist ×10.",
      "3": "Je deed ×100. Dat is van cm naar µm, niet naar mm."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "cm",
        "to": "mm",
        "value": 12,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L1-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een doos weegt 3 kilogram. Hoeveel gram is dat?",
    "options": [
      "30 g",
      "300 g",
      "3.000 g",
      "30.000 g"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-DOOS",
    "explanation": "Van kg naar gram zijn het 3 stappen omlaag. Elke stap is ×10. Dus: 3 × 1000 = 3.000 gram.",
    "distractorExplanations": {
      "0": "Je deed ×10. Dat is naar hg!",
      "1": "Je deed ×100. Dat is naar dag!",
      "3": "Een nul te veel. 1 kg = 1000 gram, dus 3 kg = 3000 gram."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 3,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L1-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een appel weegt 200 gram. Hoeveel appels wegen samen 1 kilogram?",
    "options": [
      "5 appels",
      "10 appels",
      "2 appels",
      "20 appels"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-APPEL",
    "explanation": "Stap 1: 1 kilogram = 1000 gram. Stap 2: 1000 : 200 = 5. Je hebt 5 appels nodig.",
    "distractorExplanations": {
      "1": "Je deed 1000 : 100. Maar één appel weegt 200 gram!",
      "2": "Je deed 1000 : 500. Maar één appel weegt 200 gram!",
      "3": "Je deed 1000 : 50. Maar één appel weegt 200 gram!"
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 1,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L2-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een zak aardappelen weegt 2,5 kilogram. Hoeveel gram is dat?",
    "options": [
      "2.500 gram",
      "250 gram",
      "25 gram",
      "25.000 gram"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-AARDAPPEL",
    "explanation": "Van kilogram naar gram zijn het 3 stappen omlaag op de trap. Dus: 2,5 × 1000 = 2.500 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100. Dat is van kg naar dag!",
      "2": "Je deed ×10. Dat is van kg naar hg!",
      "3": "Een nul te veel! 1 kg = 1000 gram, dus 2,5 kg = 2.500 gram."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2.5,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L1-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een pak suiker weegt 750 gram. Hoeveel kilogram is dat?",
    "options": [
      "0,75 kg",
      "7,5 kg",
      "75 kg",
      "0,075 kg"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-SUIKER",
    "explanation": "Van gram naar kilogram zijn het 3 stappen omhoog. Dus delen door 1000: 750 : 1000 = 0,75 kg.",
    "distractorExplanations": {
      "1": "Je verplaatste de komma één plek in plaats van drie plekken.",
      "2": "Je deed ×100 in plaats van ÷1000.",
      "3": "Je deelde door 10.000. Dat is één stap te veel."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "g",
        "to": "kg",
        "value": 750,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L1-004",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een puppy weegt 1,2 kilogram. Hoeveel gram is dat?",
    "options": [
      "120 gram",
      "1.200 gram",
      "12.000 gram",
      "1,2 gram"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-PUPPY",
    "explanation": "Van kg naar g zijn het 3 stappen omlaag. Dus: 1,2 × 1000 = 1.200 gram.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van kg naar dag!",
      "2": "Je zette er twee nullen te veel bij. Het is ×1000.",
      "3": "Je verplaatste de komma de verkeerde kant op."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 1.2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GEW-L1-005",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een zakje rozijnen weegt 50 gram. Hoeveel gram wegen 4 zakjes?",
    "options": [
      "150 gram",
      "200 gram",
      "250 gram",
      "400 gram"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-GEW-ROZIJNEN",
    "explanation": "Je hebt 4 zakjes van 50 gram: 4 × 50 = 200 gram.",
    "distractorExplanations": {
      "0": "Je deed 3 × 50 in plaats van 4 × 50.",
      "2": "Je deed 5 × 50. Maar je hebt 4 zakjes.",
      "3": "Je deed 8 × 50. Dat is te veel."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Herhaald optellen",
        "content": "4 zakjes van 50 gram = 50 + 50 + 50 + 50 = 200 gram.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een kan bevat 2 liter water. Hoeveel milliliter is dat?",
    "options": [
      "200 ml",
      "2.000 ml",
      "20.000 ml",
      "2 ml"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-KAN",
    "explanation": "Van liter naar milliliter zijn het 3 stappen omlaag. Dus: 2 × 1000 = 2.000 ml.",
    "distractorExplanations": {
      "0": "Je deed ×100. Dat is van L naar dL!",
      "2": "Je zette er een nul te veel bij. Het is ×1000, niet ×10.000.",
      "3": "Je zette niets om. 2 liter is veel meer dan 2 ml."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-004",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een flesje is 500 milliliter. Hoeveel liter is dat?",
    "options": [
      "0,5 liter",
      "5 liter",
      "0,05 liter",
      "50 liter"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-FLESJE",
    "explanation": "Van ml naar liter zijn het 3 stappen omhoog. Dus delen door 1000: 500 : 1000 = 0,5 liter.",
    "distractorExplanations": {
      "1": "Je verplaatste de komma de verkeerde kant op.",
      "2": "Je deelde door 10.000. Dat is één stap te veel.",
      "3": "Je dacht dat 500 ml 50 liter is. Dat is veel te groot."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "ml",
        "to": "l",
        "value": 500,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-005",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Er zit 3 deciliter sap in een glas. Hoeveel milliliter is dat?",
    "options": [
      "30 ml",
      "300 ml",
      "3.000 ml",
      "3 ml"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-SAP",
    "explanation": "Van dl naar ml zijn het 2 stappen omlaag. Dus: 3 × 100 = 300 ml.",
    "distractorExplanations": {
      "0": "Je deed ×10. Dat is van dl naar cl.",
      "2": "Je deed ×1000. Dat is één stap te veel.",
      "3": "Je zette niets om. 3 dl is meer dan 3 ml."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "dl",
        "to": "ml",
        "value": 3,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-INH-L1-006",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Een beker is 250 milliliter. Hoeveel milliliter zit er in 4 bekers?",
    "options": [
      "750 ml",
      "1.000 ml",
      "2.500 ml",
      "4.000 ml"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-INH-BEKERS",
    "explanation": "Vier bekers van 250 ml: 4 × 250 = 1.000 ml.",
    "distractorExplanations": {
      "0": "Je deed 3 × 250. Maar het zijn 4 bekers.",
      "2": "Je deed 10 × 250. Dat is te veel.",
      "3": "Je zette er een nul te veel bij. 4 × 250 = 1.000."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Herhaald optellen",
        "content": "4 × 250 = 250 + 250 + 250 + 250 = 1.000 ml.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L1-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Reken uit: 980 - 450 =",
    "options": [
      "530",
      "430",
      "550",
      "580"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-BASIS-3",
    "explanation": "Trek de honderdtallen af: 900 - 400 = 500. Trek de tientallen af: 80 - 50 = 30. Dus 530.",
    "distractorExplanations": {
      "1": "Honderdtallen: 9 - 4 = 5, niet 4.",
      "2": "Tientallen: 8 - 5 = 3, niet 5.",
      "3": "Je bent vergeten de tientallen af te trekken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Honderdtallen",
        "content": "Trek eerst de honderdtallen af, daarna de tientallen.",
        "icon": "info"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Wat is meer: 2.500 ml of 3 liter?",
    "options": ["3 liter", "2.500 ml", "Even veel", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-ML-L-M6",
    "explanation": "3 liter = 3.000 ml. 3.000 ml is meer dan 2.500 ml.",
    "distractorExplanations": {
      "1": "2.500 ml is 2,5 liter. Dat is minder dan 3 liter.",
      "2": "Ze zijn niet even veel. 3 liter is meer.",
      "3": "Je kunt het vergelijken door om te rekenen naar dezelfde eenheid."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 3,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Wat is zwaarder: 1.800 gram of 2 kilogram?",
    "options": ["2 kilogram", "1.800 gram", "Even zwaar", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-G-KG-M6",
    "explanation": "2 kg = 2.000 gram. 2.000 gram is meer dan 1.800 gram.",
    "distractorExplanations": {
      "1": "1.800 gram is 1,8 kg. Dat is minder dan 2 kg.",
      "2": "Ze zijn niet even zwaar. 2 kg is zwaarder.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Wat is langer: 350 cm of 3 meter?",
    "options": ["350 cm", "3 meter", "Even lang", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-CM-M-M6",
    "explanation": "3 meter = 300 cm. 350 cm is meer dan 300 cm, dus 350 cm is langer.",
    "distractorExplanations": {
      "1": "3 meter is maar 300 cm. 350 cm is langer.",
      "2": "350 cm is 3,5 meter. Dat is meer dan 3 meter.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 3,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-VGL-M6-004",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Wat is meer: 750 ml of 1 liter?",
    "options": ["1 liter", "750 ml", "Even veel", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-ML-L-M6-2",
    "explanation": "1 liter = 1.000 ml. 1.000 ml is meer dan 750 ml.",
    "distractorExplanations": {
      "1": "750 ml is driekwart liter. Dat is minder dan 1 liter.",
      "2": "Ze zijn niet even veel.",
      "3": "Je kunt het vergelijken door om te rekenen."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "volume",
        "from": "l",
        "to": "ml",
        "value": 1,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-SCHAT-M6-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Hoeveel liter water past er ongeveer in een badkuip?",
    "options": ["150 liter", "15 liter", "1.500 liter", "1,5 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-BAD-M6",
    "explanation": "In een gewone badkuip past ongeveer 150 liter water.",
    "distractorExplanations": {
      "1": "Dat is maar anderhalve emmer. Een badkuip is veel groter!",
      "2": "Dat is een heel groot zwembad. Een badkuip is kleiner.",
      "3": "Dat is maar een flesje. Een badkuip is veel groter!"
    }
  },
  {
    "id": "MET-SCHAT-M6-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Hoeveel milliliter zit er in een kopje thee?",
    "options": ["200 ml", "2 liter", "20 ml", "2.000 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-THEE-M6",
    "explanation": "In een normaal kopje thee zit ongeveer 200 milliliter.",
    "distractorExplanations": {
      "1": "Dat is een hele fles. Een kopje is veel kleiner.",
      "2": "Dat is maar een klein scheutje. Een kopje is groter.",
      "3": "Dat is 2 liter. Dat past niet in een kopje!"
    }
  },
  {
    "id": "MET-SCHAT-M6-003",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Hoeveel weegt een appel ongeveer?",
    "options": ["150 gram", "15 gram", "1,5 kilogram", "1.500 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_schatten",
    "familyId": "MET-SCHAT-APPEL-M6",
    "explanation": "Een gemiddelde appel weegt ongeveer 150 gram.",
    "distractorExplanations": {
      "1": "Dat is heel licht, meer als een postzegel.",
      "2": "Dat is anderhalf kilogram. Zo zwaar is een appel niet!",
      "3": "Dat is ook anderhalf kilogram. Veel te zwaar voor een appel."
    }
  },
  {
    "id": "MET-LKOM-M6-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Reken om: 1,8 meter = ... cm",
    "options": ["180 cm", "18 cm", "1.800 cm", "108 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-LKOM-M-CM-M6",
    "explanation": "1 meter = 100 cm. 1,8 meter = 1,8 × 100 = 180 cm.",
    "distractorExplanations": {
      "1": "Je deed ×10 in plaats van ×100.",
      "2": "Je deed ×1.000. Dat is één stap te veel.",
      "3": "Je telde 8 bij 100 op. Maar 0,8 meter is 80 cm!"
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "m",
        "to": "cm",
        "value": 1.8,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-LKOM-M6-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Reken om: 0,75 km = ... meter",
    "options": ["750 m", "75 m", "7.500 m", "7,5 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_komma",
    "familyId": "MET-LKOM-KM-M-M6",
    "explanation": "1 km = 1.000 meter. 0,75 km = 0,75 × 1.000 = 750 meter.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je deed ×10. Dat is te weinig."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "length",
        "from": "km",
        "to": "m",
        "value": 0.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GKOM-M6-001",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Reken om: 0,75 kg = ... gram",
    "options": ["750 gram", "75 gram", "7.500 gram", "7,5 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-GKOM-KG-G-M6",
    "explanation": "1 kg = 1.000 gram. 0,75 kg = 0,75 × 1.000 = 750 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je deed ×10. Dat is te weinig."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 0.75,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "MET-GKOM-M6-002",
    "module": "Metriek",
    "difficulty": 103,
    "question": "Reken om: 2,25 kg = ... gram",
    "options": ["2.250 gram", "225 gram", "22.500 gram", "2.025 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht_komma",
    "familyId": "MET-GKOM-KG-G-M6-2",
    "explanation": "1 kg = 1.000 gram. 2,25 kg = 2,25 × 1.000 = 2.250 gram.",
    "distractorExplanations": {
      "1": "Je deed ×100 in plaats van ×1.000.",
      "2": "Je deed ×10.000. Dat is te veel.",
      "3": "Je maakte een kommafout. 2,25 × 1.000 = 2.250."
    },
    "visualAid": {
      "type": "stairs",
      "data": {
        "type": "weight",
        "from": "kg",
        "to": "g",
        "value": 2.25,
        "showAnimation": true
      },
      "showWhen": "wrong"
    }
  }
]